import router from '@/router/router';
import { success, error } from '@/helpers/utils';

export const Reset = {
    state: {},
    mutations: {},
    getters: {
        shouldBeResetted(state, getters) {
            if ([7000002, 7000003, 7000004, 7000005, 7000006].includes(getters.getUserId)) {
                let last_reset = getters.getProp('tecpage.user.settings.misc.last_reset');
                if (last_reset === undefined) {
                    return true;
                }
                let d1 = new Date(),
                    d2 = new Date(last_reset);
                // add hours
                d2.setTime(d2.getTime() + 24 * 60 * 60 * 1000);
                return d1 > d2;
            }
            return false;
        }
    },
    actions: {
        async resetData(context, chosenPackage) {
            try {
                /* fully reset tecpage table */
                await context.dispatch('setProp', {
                    source: 'tecpage.user',
                    value: {
                        modules: {},
                        pages: {},
                        menus: {},
                        settings: {
                            fontfamily: null,
                            colorscheme: null,
                            theme: null,
                            iconstyle: null,
                            misc: null
                        }
                    }
                });

                /* reset only part of deha table */
                await context.dispatch('setProp', {
                    source: 'deha.user.paket',
                    value: chosenPackage
                });
                await context.dispatch('setProp', {
                    source: 'deha.user.misc',
                    value: {
                        contact_person: context.getters.getProp('deha.user.misc.contact_person'),
                        contact_person_2: context.getters.getProp(
                            'deha.user.misc.contact_person_2'
                        ),
                        contact_person_3: context.getters.getProp('deha.user.misc.contact_person_3')
                    }
                });

                let last_reset = new Date();
                last_reset =
                    last_reset.getFullYear() +
                    '-' +
                    ('0' + (last_reset.getMonth() + 1)).slice(-2) +
                    '-' +
                    ('0' + last_reset.getDate()).slice(-2) +
                    ' ' +
                    ('0' + last_reset.getHours()).slice(-2) +
                    ':' +
                    ('0' + last_reset.getMinutes()).slice(-2) +
                    ':' +
                    ('0' + last_reset.getSeconds()).slice(-2);
                await context.dispatch('setProp', {
                    source: 'tecpage.user.settings.misc.last_reset',
                    value: last_reset
                });
                await context.dispatch('updateHtmlClasses');
                await context.dispatch('saveAllData');
                success('Erfolgreich zurückgesetzt!');
                await new Promise((resolve) => {
                    router.push({ name: 'wizard' }, () => {
                        resolve();
                    });
                });
            } catch (e) {
                error('Es ist ein Fehler aufgetreten!');
                console.error(e);
                return Promise.reject();
            }
        }
    }
};
